import React, { useState } from 'react';
import { Button } from '../UI/Button';
interface IntentConfirmationProps {
  onConfirm: (understood: boolean) => void;
}
export const IntentConfirmation = ({
  onConfirm
}: IntentConfirmationProps) => {
  const [selection, setSelection] = useState<string | null>(null);
  const handleSubmit = e => {
    e.preventDefault();
    onConfirm(selection === 'yes');
  };
  return <div className="bg-white p-6 rounded-lg border-2 border-gray-300" data-id="element-258" data-mp="3uoz7n3q8bvo8">
      <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-259" data-mp="3umml0d9j0x4u">
        Before You Continue
      </h2>
      <p className="text-gray-700 mb-8" data-id="element-260" data-mp="3c5w4qvyz5ti">
        Our mission is to serve you well. The rules of engagement are not meant
        to restrict your participation but to ensure we maintain a strong and
        mutually supportive community. By creating a space where opportunities,
        ideas, and support flow freely, we can help each other achieve personal
        and professional success.
      </p>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-261" data-mp="3gqskahiwpe2t">
        <div data-id="element-262" data-mp="2xlaqsabibcm">
          <label className="block text-gray-700 font-medium mb-4" data-id="element-263" data-mp="2x1t7cokxoz4">
            Do you understand and agree with this intent?
          </label>
          <div className="space-y-3" data-id="element-264" data-mp="bzb1dvwdl69c">
            <div className="flex items-center" data-id="element-265" data-mp="by9sny2u0vus">
              <input type="radio" id="yes" name="intent" value="yes" checked={selection === 'yes'} onChange={() => setSelection('yes')} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-266" data-mp="7xzkqfvhbvda" />
              <label htmlFor="yes" className="text-gray-700 flex items-center" data-id="element-267" data-mp="3beojhfotm0se">
                <span className="mr-2" data-id="element-268" data-mp="3bclk451s2vb0">✅</span> Yes, I totally understand
              </label>
            </div>
            <div className="flex items-center" data-id="element-269" data-mp="3p7xqxat7kc8a">
              <input type="radio" id="more-details" name="intent" value="more-details" checked={selection === 'more-details'} onChange={() => setSelection('more-details')} className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-270" data-mp="3kebjbx1wiyjc" />
              <label htmlFor="more-details" className="text-gray-700 flex items-center" data-id="element-271" data-mp="2snyenlfow3ww">
                <span className="mr-2" data-id="element-272" data-mp="vn19407at3c4">❓</span> Kindly provide more details
              </label>
            </div>
          </div>
        </div>
        <Button type="submit" disabled={!selection} className="w-full py-3" data-id="element-273" data-mp="15ddq5ifwmedi">
          Continue
        </Button>
      </form>
    </div>;
};